import React from 'react';
import { useMutation, useQueryClient } from 'react-query';
import externalApi from '../../api';

type EditTrackedEquipmentServiceRequest = {
  trackedEquipmentServiceId: string;
  onHours: number;
  offHours: number;
  lastUpdatedUserId: string;
};

type EditTrackedEquipmentServiceResponse = {
  trackedEquipmentServiceId: number;
};

function editTrackedEquipmentService(
  request: EditTrackedEquipmentServiceRequest
): Promise<EditTrackedEquipmentServiceResponse> {
  return externalApi.patch(`TrackedEquipmentService/patch/hours`, { json: request }).json();
}

function useEditTrackedEquipmentServiceHours() {
  const queryClient = useQueryClient();
  return useMutation(
    (request: EditTrackedEquipmentServiceRequest) => editTrackedEquipmentService(request),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['AllTrackedEquipmentService']);
      },
    }
  );
}
export { useEditTrackedEquipmentServiceHours };
